package dev.bitspittle.droidconSf24.pages.sections.kobweb.silk

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun Responsive1Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/silk/Responsive1.md", mapOf("behaviors" to listOf("auto-progress-fragments 200")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("responsive") }) {
                org.jetbrains.compose.web.dom.Text("Responsive")
            }
            dev.bitspittle.droidconSf24.components.widgets.Code("""val ResponsiveStyle = CssStyle {
    base { Modifier.backgroundColor(Colors.Red) }
    Breakpoint.SM { Modifier.backgroundColor(Colors.Yellow) }
    Breakpoint.MD { Modifier.backgroundColor(Colors.Green) }
    Breakpoint.LG { Modifier.backgroundColor(Colors.Blue) }
}
""", "kotlin 0|1|2|3|4|5|2-5 [code]")
            AnimatedResponsiveExample(Modifier.dataId("responsive"))
        }
    }
}
